import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import CommonModal from "./CommonModal";
import Button from "../Elements/Button";

const PageLimitConfirmModal = ({ show, pageCount, onConfirm, onCancel }) => {
  return (
    <CommonModal
      title={"Large PDF"}
      modalStatus={show}
      changeActiveStatus={onCancel}
      classList="header-profile-modal-wrapper alert-modal"
      showFooter={false}
      centered
    >
      <div className="clone-modal page-limit-modal">
        <div className="page-limit-summary">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <span>
            This PDF has <strong>{pageCount} pages</strong> — more than the recommended 50 for a KDF.
          </span>
        </div>
        <ul className="page-limit-reasons">
          <li>It will take longer to process and display document to reciepents.</li>
          <li>Setting up interactive elements, tags, and questions across that many pages takes more time.</li>
          <li>Recipients tend to engage less with very long documents.</li>
        </ul>
        <div className="page-limit-question">Do you wish to continue?</div>
        <div className="kdf-btn mt-3">
          <Button
            text={"No"}
            classList={"alert"}
            addonClass={"me-1 px-2"}
            onClick={onCancel}
          />
          <Button
            text={"Yes"}
            classList={"success"}
            type="submit"
            addonClass={"px-2 common-modal-yes-button"}
            onClick={onConfirm}
          />
        </div>
      </div>
    </CommonModal>
  );
};

export default PageLimitConfirmModal;
